import React from 'react';
import swal from 'sweetalert';
import i18n from '../../../../../i18n';
import { deductFund } from '../../../../../models/auctionDelivery';
import { CustomModal } from '../../../../common/CustomModal';
import { Loader2 } from 'lucide-react';

export class AuctionFundDeductModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      input: {},
      errors: {},
      fileInputs: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      input: { ...prevState.input, [name]: value },
    }));
  };

  validateOfflineForm = () => {
    const required = ['withdraw_amount'];

    for (let field of required) {
      if (!this.state.input[field]) {
        return false;
      }
    }
  };

  async handleSubmit(event) {
    const { auction } = this.props;
    event.preventDefault();

    const serviceCharge = parseFloat(auction?.service_charge || 0);
    const vatServiceCharge = parseFloat(auction?.vat_service_charge || 0);

    const computedTotalAmount =
      auction?.collection_type === 3
        ? serviceCharge + vatServiceCharge
        : parseFloat(auction?.total_amount || 0);

    try {
      this.setState({ loading: true });
      const payload = {
        debit: computedTotalAmount,
        auction: auction.id,
        group: auction.group_id,
        user: auction.user_id,
      };

      const response = await deductFund(payload);
      if (response && response.success) {
        swal(i18n.t('success'), i18n.t('fund_added'), 'success');
        this.setState({ loading: false });
        if (this.props.onSuccess) {
          this.props.onSuccess();
        } else {
          this.props.onClose();
        }
      } else {
        swal(i18n.t('failed'), response.message, 'error');
        this.setState({ loading: false });
      }
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
    }
  }

  render() {
    const { show, onClose, auction } = this.props;
    const { loading, errors } = this.state;

    const serviceCharge = parseFloat(auction?.service_charge || 0);
    const vatServiceCharge = parseFloat(auction?.vat_service_charge || 0);

    const computedTotalAmount =
      auction?.collection_type === 3
        ? serviceCharge + vatServiceCharge
        : parseFloat(auction?.total_amount || 0);

    return (
      <CustomModal isOpen={show} header={i18n.t('fund_deduct')} onClose={onClose}>
        {/* Form Content */}
        <div className="wallet-form-container">
          <div className="stats-section-center">
            <div className="stat-box-center">
              <div className="stat-label-center">Wallet</div>
              <div className="stat-value-center">{auction?.wallet_amount || 0} SAR</div>
            </div>

            <div className="stat-box">
              <div className="stat-label-center">Client</div>
              <div className="stat-value-center amount">{auction?.client_amount || 0} SAR</div>
            </div>
          </div>
          <form className="wallet-form" autoComplete="off">
            <div className="wallet-form-content">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="wallet-form-label">{i18n.t('actual_total')}</label>
                  <input
                    type="text"
                    name="actual_total"
                    value={computedTotalAmount}
                    onChange={this.handleChange}
                    className="wallet-form-input"
                    disabled
                    placeholder={computedTotalAmount}
                  />
                  <div className="wallet-error">{errors.actual_total}</div>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="wallet-form-label">{i18n.t('paid_amount')}</label>
                  <input
                    type="text"
                    name="paid_amount"
                    value={auction?.paid_amount || 0}
                    onChange={this.handleChange}
                    className="wallet-form-input"
                    disabled
                    placeholder={auction?.paid_amount}
                  />
                  <div className="wallet-error">{errors.paid_amount}</div>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="wallet-form-label">{i18n.t('withdraw_amount')}</label>
                  <input
                    type="text"
                    name="withdraw_amount"
                    value={computedTotalAmount}
                    onChange={this.handleChange}
                    className="wallet-form-input"
                    disabled
                    placeholder={computedTotalAmount}
                  />
                  <div className="wallet-error">{errors.withdraw_amount}</div>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="wallet-form-label">{i18n.t('remarks')}</label>
                  <input
                    type="text"
                    name="total_amount"
                    value={auction?.approval_remarks || i18n.t('no_remarks')}
                    className="wallet-form-input"
                    disabled
                  />
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="wallet-actions">
              <button type="button" className="modal-btn btn-cancel" onClick={onClose}>
                {i18n.t('cancel')}
              </button>
              <button
                type="button"
                className="modal-btn btn-confirm"
                onClick={this.handleSubmit}
                disabled={
                  loading ||
                  parseFloat(auction?.client_amount || 0) < parseFloat(computedTotalAmount)
                }
              >
                {loading ? (
                  <span
                    style={{
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    <Loader2 className="animate-spin" size={16} /> {i18n.t('deduct')}
                  </span>
                ) : (
                  i18n.t('deduct')
                )}
              </button>
            </div>
          </form>
        </div>
      </CustomModal>
    );
  }
}
